import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import images from "../../assets/images/shortcuts";
import Shortcut from "../../framework/Shortcut";
import { executeScroll } from "../../utils/utils";
import { allMenus } from "./spotlightConstants";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./Menu.module.css";
const Menu = ({ aliasSearchType = () => { } }) => {
  const menuThreshold = 4;
  const [activeMainIndex, setActiveMainIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  const [isMore, setIsMore] = useState(false);
  const subMenuRef = useRef();
  const { enter } = images;
  const { setAddNewTab, setShowSpotlight } = useContext(GlobalContext);

  const allAccessibleMainMenus = () => {
    return allMenus.filter((menu) => menu.isAccessible);
  };
  const allAccessibleSubMenus = (submenus) => {
    return submenus?.filter((submenu) => submenu.isAccessible);
  };

  const clickHandler = useCallback(
    (component) => {
      setAddNewTab({ component: component });
      setShowSpotlight(false);
    },
    [setAddNewTab, setShowSpotlight]
  );
  const menuListener = useCallback(
    (e) => {
      const key = e.key.toLowerCase();
      const shiftKey = e.shiftKey;
      if (key === "tab") {
        if (shiftKey) {
          if (activeMainIndex === 0) return;
          if (isMore) {
            setIsMore(false);
            setActiveSubIndex(0);
            setActiveMainIndex(menuThreshold - 1);
            return;
          }
          setActiveSubIndex(0);
          setActiveMainIndex((prev) => prev - 1);
          return;
        }
        if (isMore) return; //this will change because of C:
        if (activeMainIndex === allAccessibleMainMenus().length - 1) return;
        if (activeMainIndex + 1 === menuThreshold) {
          setIsMore(true);
        }
        setActiveSubIndex(0);
        setActiveMainIndex((prev) => prev + 1);
        return;
      }
      if (key === "arrowup") {
        if (isMore && activeSubIndex === 0) {
          if (isMore && activeMainIndex === menuThreshold) return;
          if (isMore && activeMainIndex - 3 < menuThreshold) return;
          setActiveMainIndex((prev) => prev - 3);
          setActiveSubIndex(
            allAccessibleSubMenus(
              allAccessibleMainMenus()[activeMainIndex - 3].sub_menus
            ).length - 1
          );
          executeScroll(subMenuRef);
          return;
        }
        if (activeSubIndex === 0) return;
        setActiveSubIndex((prev) => prev - 1);
        executeScroll(subMenuRef);
        return;
      }
      if (key === "arrowdown") {
        if (
          isMore &&
          activeSubIndex ===
          allAccessibleSubMenus(
            allAccessibleMainMenus()[activeMainIndex].sub_menus
          ).length -
          1
        ) {
          if (activeMainIndex === allAccessibleMainMenus().length - 1) return;
          if (activeMainIndex + 3 > allAccessibleMainMenus().length - 1) return;
          setActiveMainIndex((prev) => prev + 3);
          setActiveSubIndex(0);
          executeScroll(subMenuRef);
          return;
        }
        if (
          activeSubIndex ===
          allAccessibleSubMenus(
            allAccessibleMainMenus()[activeMainIndex].sub_menus
          ).length -
          1
        )
          return;
        setActiveSubIndex((prev) => prev + 1);
        executeScroll(subMenuRef);
        return;
      }
      if (isMore && key === "arrowleft") {
        if (menuThreshold % 3 === activeMainIndex % 3) {
          return;
        }
        setActiveMainIndex((prev) => prev - 1);
        if (
          allAccessibleSubMenus(
            allAccessibleMainMenus()[activeMainIndex - 1].sub_menus
          ).length -
          1 <
          activeSubIndex
        )
          setActiveSubIndex(
            allAccessibleSubMenus(
              allAccessibleMainMenus()[activeMainIndex - 1].sub_menus
            ).length - 1
          );
        return;
      }
      if (isMore && key === "arrowright") {
        if ((menuThreshold + 2) % 3 === activeMainIndex % 3) return;
        if (activeMainIndex + 1 >= allAccessibleMainMenus().length) return;
        setActiveMainIndex((prev) => prev + 1);
        if (
          allAccessibleSubMenus(
            allAccessibleMainMenus()[activeMainIndex + 1].sub_menus
          ).length -
          1 <
          activeSubIndex
        )
          setActiveSubIndex(
            allAccessibleSubMenus(
              allAccessibleMainMenus()[activeMainIndex + 1].sub_menus
            ).length - 1
          );

        return;
      }
      if (key === "enter") {
        setTimeout(() => {
          subMenuRef.current.click();
        }, 0);
        return;
      }
    },
    [activeMainIndex, activeSubIndex, isMore]
  );
  useEffect(() => {
    document.addEventListener("keyup", menuListener, false);
    return () => {
      document.removeEventListener("keyup", menuListener, false);
    };
  }, [menuListener]);

  return (
    <div className={classes["menu"]}>
      <div className={classes["menu-headers"]}>
        {/* Menu Header */}
        {allAccessibleMainMenus().map((menu, index) => {
          return (
            index < menuThreshold && (
              <div
                key={`menu_${index}`}
                onClick={(e) => {
                  setIsMore(false);
                  setActiveMainIndex(index);
                }}
                className={`${classes["menu-header-item"]} ${activeMainIndex === index && classes["active"]
                  }`}
              >
                <div className={`${classes["menu-header-icon"]}`}>
                  <img
                    width={22}
                    height={22}
                    src={menu.menu_icon}
                    alt={menu.label}
                  />
                </div>
                <div className={classes["menu-header-label"]}>{menu.label}</div>
              </div>
            )
          );
        })}
      </div>
      {/* Sub menus */}
      {!isMore && (
        <div className={classes["menu-header-content"]}>
          {allAccessibleSubMenus(
            allAccessibleMainMenus()[activeMainIndex].sub_menus
          )?.map((sub_menu, subindex) => {
            return (
              <div
                key={`sub_menu_${activeMainIndex}_${subindex}`}
                ref={subindex === activeSubIndex ? subMenuRef : null}
                className={`${classes["more-menu-column"]} ${subindex === activeSubIndex && classes["active"]
                  }`}
                onClick={(e) => clickHandler(sub_menu.component)}
              >
                {/* td */}
                <div className={classes["sub-menu-header"]}>
                  <div className={classes["sub-menu-icon"]}>
                    <img
                      src={
                        sub_menu.menu_icon_active
                          ? sub_menu.menu_icon_active
                          : allAccessibleMainMenus()[activeMainIndex]
                            .menu_icon_active
                      }
                      alt={allAccessibleMainMenus()[activeMainIndex].label}
                    />
                  </div>
                  <div className={classes["sub-menu-label"]}>
                    {sub_menu.sub_menu}
                  </div>
                </div>
                {subindex === activeSubIndex && (
                  <div className={classes["sub-menu-shortcut"]}>
                    <Shortcut keys={[{ image: enter }]} />
                  </div>
                )}
                <div className={classes["sub-menu-seperator"]}></div>
              </div>
            );
          })}
        </div>
      )}
      {/* Sub menus in more tab */}
      {isMore && (
        <div className={classes["more-header-content"]}>
          {allAccessibleMainMenus().map((menu, index) => {
            return (
              index >= menuThreshold && (
                <div key={`menu_${index}`} className={classes["more-menu-row"]}>
                  {/* tr */}
                  <div className={classes["more-menu-header"]}>
                    {/* th */}
                    {menu.label}
                  </div>
                  {allAccessibleSubMenus(menu.sub_menus)?.map(
                    (sub_menu, subindex) => {
                      return (
                        <div
                          key={`sub_menu_${index}_${subindex}`}
                          ref={
                            index === activeMainIndex &&
                              subindex === activeSubIndex
                              ? subMenuRef
                              : null
                          }
                          className={`${classes["more-menu-column"]} ${index === activeMainIndex &&
                            subindex === activeSubIndex &&
                            classes["active"]
                            }`}
                          onClick={(e) => clickHandler(sub_menu.component)}
                        >
                          {/* td */}
                          <div className={classes["sub-menu-header"]}>
                            <div className={classes["sub-menu-icon"]}>
                              <img
                                src={
                                  sub_menu.menu_icon_active
                                    ? sub_menu.menu_icon_active
                                    : menu.menu_icon_active
                                }
                                alt={menu.label}
                              />
                            </div>
                            <div className={classes["sub-menu-label"]}>
                              {sub_menu.sub_menu}
                            </div>
                          </div>
                          {index === activeMainIndex &&
                            subindex === activeSubIndex && (
                              <div className={classes["sub-menu-shortcut"]}>
                                <Shortcut keys={[{ image: enter }]} />
                              </div>
                            )}
                          <div className={classes["sub-menu-seperator"]}></div>
                        </div>
                      );
                    }
                  )}
                </div>
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Menu;
